import React from 'react'
import styles from './Dropdown.module.css'
import { Link } from 'react-router-dom';

export type DropdownProps = {
    items: Array<{
        title: string;
        navigate: string;
    }>;
    isActive: boolean;
}

const Dropdown = (props: DropdownProps) => {
    return (
        <div className={`${styles.container} ${props.isActive && styles.active}`}>
            {props.items.map((item, index) => (
                <Link key={index} to={item.navigate}>{item.title}</Link>
            ))}
        </div>
    )
}

export default Dropdown
